
import Devices from "../../../assets/filled/Devices.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DevicesIcon({ className, dataTestid = "DevicesIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Devices data-testid={dataTestid} className={classes} {...rest} />
  );
}
